import React from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { COURSE_URL } from "../../constants";
import { apiDefine } from "../../api/web";
// import AXIOS from '../../api/axios';
import clientApi from "../../api/client";
import UA from "../../utils/ua";
import "./style.less";
import MemberPage from "../memberPage/MemberPage";
import AppPayPage from "../payPage/AppPayPage";
import WebPayPage from "../payPage/WebPayPage"; // pc、pad会员中心
import H5PayPage from "../payPage/H5PayPage"; // h5支付
import DownloadPage from "../customerPage/DownloadPage"; // 下载页

import Paylink from "../payPage/Paylink"; // 扫码支付页
import SharePage from "../sharePage/SharePage"; // 作业分享页
import SuccessPage from "../payPage/SuccessPage"; // 支付成功页
import RulesPage from "../customerPage/RulesPage"; // 用户协议
import GuidePage from "../guidePage/GuidePage"; // 新手引导
import Privacy from "../privacyPage/privacyPage"; // 隐私协议
import Agreement from "../../components/agreement/index"; // 爱课用户服务协议
import AgreementPd from "../../components/agreementPd/index"; // 爱课精品小班用户服务协议

import HomeworkPage from "../homeworkNewPage/HomeworkPage"; // 作业主页
import CarriagePage from "../homeworkNewPage/CarriagePage"; // 作业冰淇淋车
import ArcheryPage from "../homeworkNewPage/ArcheryPage"; // 作业射箭
import CastlePage from "../homeworkNewPage/CastlePage"; // 作业烟花
import HomeworkResultPage from "../homeworkNewPage/HomeworkResultPage"; // 作业结果页

import CoursedetailPage from "../courseDetailPage/CourseDetailPage"; // 课程详情
import PhonicsDetaiPage from "../phonicsDetailPage/PhonicsDetaiPage"; // 课程详情
import MemberNewPage from "../memberNewPage/MemberNewPage"; // 会员中心页
import AddressPage from "../experimentOrderPage/AddressPage"; // nasa收货地址
import NASAPayPage from "../experimentOrderPage/NASAPayPage"; // nasa支付页
import DiscountCouponPage from "../experimentOrderPage/DiscountCouponPage"; // 选择优惠券页面
import LogisticsPage from "../experimentOrderPage/LogisticsPage"; // 物流详情页
import PaymentAgreement from "../paymentAgreement/paymentAgreement"; // 用户支付协议
import UniversePayPage from "../UniversePayPage/UniversePayPage";
import AchievementRulesPage from "../customerPage/achievementRules";
import PuDetaiPage from "../puDetailPage/puDetailPage";
import FeedbackPage from "../feedbackPage/feedbackPage";
import FeedbackDetailPage from "../feedbackPage/feedbackDetailPage";
import DailyAttendance from "../dailyAttendancePage"; // 每日打卡页
import DailyAttendanceRules from "../dailyAttendancePage/rules"; // 每日打卡规则详情页
import AddAddressPage from "../addAddressPage"; // 每日打卡页

import { myStorage } from "../../utils/tools";
import RulesPageBinguo from "../customerPage/RulesPageBinguo";
import PrivacyBinguoPage from "../privacyPage/privacyBinguoPage";
import RulesPageOMO from "../customerPage/RulesPageOMO";
import PrivacyOMO from "../privacyPage/privacyOMO";
import anniversaryPage from "../anniversaryPage/anniversary";
import Privacy2Page from "../privacyPage/privacy2Page";
import Privacy3Page from "../privacyPage/privacy3Page";
import Privacy4Page from "../privacyPage/privacy4Page";
import PrivacyPd from "../privacyPage/privacyPd";
import ServiceusePage from "../privacyPage/ServiceusePage";
import PrivacyBinguo2Page from "../privacyPage/privacyBinguo2Page";
import CourseOutline1Page from "../courseOutlinePage/courseOutline1Page";
import CourseOutline2Page from "../courseOutlinePage/courseOutline2Page";
import CourseOutline3Page from "../courseOutlinePage/courseOutline3Page";
import CourseOutlinePro1Page from "../courseOutlinePage/courseOutlinePro1Page";
import CourseOutlinePro2Page from "../courseOutlinePage/courseOutlinePro2Page";
import CourseOutlinePro3Page from "../courseOutlinePage/courseOutlinePro3Page";
import CourseOutlinePro4Page from "../courseOutlinePage/courseOutlinePro4Page";
import CourseOutlinePro5Page from "../courseOutlinePage/courseOutlinePro5Page";
import CourseOutlinePro6Page from "../courseOutlinePage/courseOutlinePro6Page";
import CourseOutlinePro7Page from "../courseOutlinePage/courseOutlinePro7Page";
import CourseOutlinePro8Page from "../courseOutlinePage/courseOutlinePro8Page";
import DiamondShop from "../diamondShop";
import GuideWXPage from "../guideWXPage";
import webviewPage from "../testPage/webview";
import LearningReport from "../learningReport";
import ReadWorks from "../readWorks";
import BannerArticlePage1 from "../bannerArticle/page1"; // 客户端banner静态页面1
import BannerArticlePage2 from "../bannerArticle/page2"; // 客户端banner静态页面2
import AccountLogOff from "../account/logoff"; // 账号注销
import AccountManage from "../account/manage"; // 账号管理
import ClassRegularPlan from "../classRegularPlan/classRegularPlan"; // 学习计划
import Organization from '../lesson2/organization';
import OrgSelect from '../lesson2/orgSelect';
class RouteComponent extends React.Component {
    constructor(props) {
        super(props);
        myStorage.init();
        this.storage = myStorage;
        this.state = {};
    }

    componentWillMount() {
        let clientData = {
            token: "",
            device: "",
        };
        if (UA.ACClient) {
            const { token, device, userId, channel } =
                JSON.parse(clientApi.getClientDataSync({ data: ["token", "device", "userId", "channel"] })) || {};
            clientData = { token };
            clientData.device = device || "Android";
            this.storage.setItem("ac_token", token);
            this.storage.setItem("ac_id", userId);
            this.storage.setItem("ac_device", device);
            this.storage.setItem("channelId", channel);
        } else {
            // if(!window.localStorage.getItem('ac_token')){
            //   AXIOS.login({
            //     data:{phone:'18072791152',smsCode:200420,channel:'PC', debug:1}
            //   },function(res,err){
            //     if(err) console.log(err);
            //     else{
            //       window.token = res.accessToken;
            //       window.localStorage.setItem('ac_token', res.accessToken);
            //       window.localStorage.setItem('ac_id', res.id);
            //       window.location.reload();
            //     }
            //   })
            // }
        }
        this.storage.setItem("panda_client_data", JSON.stringify(clientData));
    }

    componentDidMount() {
        apiDefine({
            apiName: "sendClientData",
            fn: function (res) {
                if (res) {
                    const data = JSON.parse(res);
                    window.myContext = { ...window.myContext, ...data };
                }
            },
        });
    }
    render() {
        return (
            <Switch>
                <Route path={`${COURSE_URL}/webpay`} component={WebPayPage} />
                <Route path={`${COURSE_URL}/apppay`} component={AppPayPage} />
                <Route path={`${COURSE_URL}/h5pay`} component={H5PayPage} />
                <Route path={`${COURSE_URL}/paylink`} component={Paylink} />
                <Route path={`${COURSE_URL}/share`} component={SharePage} />
                <Route path={`${COURSE_URL}/success`} component={SuccessPage} />
                <Route path={`${COURSE_URL}/customerrules`} component={RulesPage} />
                <Route path={`${COURSE_URL}/customerrules-binguo`} component={RulesPageBinguo} />
                <Route path={`${COURSE_URL}/customerrules-omo`} component={RulesPageOMO} />
                <Route path={`${COURSE_URL}/achievementrules`} component={AchievementRulesPage} />
                <Route path={`${COURSE_URL}/download`} component={DownloadPage} />
                <Route path={`${COURSE_URL}/member`} component={MemberPage} />
                <Route path={`${COURSE_URL}/membernew`} component={MemberNewPage} />
                <Route path={`${COURSE_URL}/guide`} component={GuidePage} />
                <Route path={`${COURSE_URL}/privacy`} component={Privacy} />
                <Route path={`${COURSE_URL}/privacy2`} component={Privacy2Page} />
                <Route path={`${COURSE_URL}/privacy3`} component={Privacy3Page} />
                <Route path={`${COURSE_URL}/privacyPd`} component={PrivacyPd} />
                <Route path={`${COURSE_URL}/VRsafe`} component={Privacy4Page} />
                <Route path={`${COURSE_URL}/Serviceuse`} component={ServiceusePage} />
                <Route path={`${COURSE_URL}/privacy-binguo`} component={PrivacyBinguo2Page} />
                <Route path={`${COURSE_URL}/privacy-binguo2`} component={PrivacyBinguoPage} />
                <Route path={`${COURSE_URL}/privacy-omo`} component={PrivacyOMO} />
                <Route path={`${COURSE_URL}/address`} component={AddressPage} />
                <Route path={`${COURSE_URL}/nasamk`} component={NASAPayPage} />
                <Route path={`${COURSE_URL}/phonicsmk`} component={UniversePayPage} />
                <Route path={`${COURSE_URL}/universemk`} component={UniversePayPage} />
                <Route path={`${COURSE_URL}/discountcoupon`} component={DiscountCouponPage} />
                <Route path={`${COURSE_URL}/paymentAgreement`} component={PaymentAgreement} />
                <Route path={`${COURSE_URL}/logistics`} component={LogisticsPage} />
                <Route path={`${COURSE_URL}/nasadetail`} component={CoursedetailPage} />
                <Route path={`${COURSE_URL}/phonicsdetail`} component={PhonicsDetaiPage} />
                <Route path={`${COURSE_URL}/pudetail`} component={PuDetaiPage} />
                <Route path={`${COURSE_URL}/coursedetail`} component={CoursedetailPage} />
                {/* <Route path={`${COURSE_URL}/homeworkresult`} component={HomeworkResultPage} /> */}
                <Route path={`${COURSE_URL}/homework/index`} component={HomeworkPage} />
                <Route path={`${COURSE_URL}/homework/result`} component={HomeworkResultPage} />
                <Redirect
                    exact
                    from={`${COURSE_URL}/homework`}
                    to={{
                        pathname: `${COURSE_URL}/homework/index`,
                        search: window.location.search,
                    }}
                />
                <Route path={`${COURSE_URL}/homework/castle/:index`} component={CastlePage} />
                {/* <Route path={`${COURSE_URL}/homework/castle/:index`} component={Homework} /> */}
                <Route path={`${COURSE_URL}/homework/archery/:index`} component={ArcheryPage} />
                <Route path={`${COURSE_URL}/homework/carriage/:index`} component={CarriagePage} />
                <Route path={`${COURSE_URL}/feedback/:id`} component={FeedbackDetailPage} />
                <Route path={`${COURSE_URL}/feedback`} component={FeedbackPage} />
                <Route path={`${COURSE_URL}/anniversary`} component={anniversaryPage} />
                <Route path={`${COURSE_URL}/courseoutline-p1`} component={CourseOutline1Page} />
                <Route path={`${COURSE_URL}/courseoutline-p2`} component={CourseOutline2Page} />
                <Route path={`${COURSE_URL}/courseoutline-p3`} component={CourseOutline3Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro1`} component={CourseOutlinePro1Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro2`} component={CourseOutlinePro2Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro3`} component={CourseOutlinePro3Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro4`} component={CourseOutlinePro4Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro5`} component={CourseOutlinePro5Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro6`} component={CourseOutlinePro6Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro7`} component={CourseOutlinePro7Page} />
                <Route path={`${COURSE_URL}/courseoutline-pro8`} component={CourseOutlinePro8Page} />
                <Route path={`${COURSE_URL}/diamondshop`} component={DiamondShop} />
                <Route path={`${COURSE_URL}/guidewx`} component={GuideWXPage} />
                <Route path={`${COURSE_URL}/testPage`} component={webviewPage} />
                <Route path={`${COURSE_URL}/learning-report`} component={LearningReport} />
                <Route path={`${COURSE_URL}/agreement`} component={Agreement} />
                <Route path={`${COURSE_URL}/agreementPd`} component={AgreementPd} />
                <Route path={`${COURSE_URL}/daily/attendance/rules`} component={DailyAttendanceRules} exact />
                <Route path={`${COURSE_URL}/daily/attendance`} component={DailyAttendance} exact />
                <Route path={`${COURSE_URL}/daily/address`} component={AddAddressPage} exact />
                <Route path={`${COURSE_URL}/read/works`} component={ReadWorks} exact />
                <Route path={`${COURSE_URL}/banner/article1`} component={BannerArticlePage1} exact />
                <Route path={`${COURSE_URL}/banner/article2`} component={BannerArticlePage2} exact />
                <Route path={`${COURSE_URL}/account/logoff`} component={AccountLogOff} exact />
                <Route path={`${COURSE_URL}/account/manage`} component={AccountManage} exact />
                <Route path={`${COURSE_URL}/classRegularPlan`} component={ClassRegularPlan} exact />
                <Route path={`${COURSE_URL}/lesson2/organization`} component={Organization} exact />
                <Route path={`${COURSE_URL}/lesson2/org-select`} component={OrgSelect} exact />
            </Switch>
        );
    }
}

export default withRouter(RouteComponent);



// WEBPACK FOOTER //
// ./src/components/RouteComponent/main.js